@if (isLoggedIn()) {
<p-menubar [model]="items()" [pt]="ptMenubar">
  <ng-template #start>
    <div class="brand-wrap" routerLink="/">
      <img src="/asa-logo-mobile.svg" alt="" class="brand-image" />
    </div>
  </ng-template>
</p-menubar>
} @else {
<header class="site-header">
  <div class="header-inner">
    <div class="wp-block-site-logo">
      <a routerLink="">{{ 'navbar.title' | transloco }}</a>
    </div>
    <ul class="navigation-meta">
      <li>
        <a
          class="login-link"
          role="button"
          tabindex="0"
          (click)="login()"
          (keydown.enter)="login()"
          (keydown.space)="login()"
          >{{ 'navbar.login' | transloco }}</a
        >
      </li>
      @for (lang of languages; track lang) {
      <li [class.current-lang]="currentLanguage() === lang">
        <a
          role="button"
          tabindex="0"
          (click)="setLanguage(lang)"
          (keydown.enter)="setLanguage(lang)"
          (keydown.space)="setLanguage(lang)"
          >{{ lang }}</a
        >
      </li>
      }
    </ul>
  </div>
</header>
} @if(loadingStore.isRouteLoading()){
<p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
}@if(maintenanceMessage()){
<p-message severity="warn"> {{ maintenanceMessage() }} </p-message>
} @if(showRecertificationBanner()){
<p-message severity="error" routerLink="/firstaid/registration">
  {{'message.recert' | transloco}}
  <i class="pi pi-spin pi-arrow-right"></i>
</p-message>
}
